<template>
  <div
    id="loadIconContainer"
    data-testid="load-icon"
    :style="{width: size * 1.5 + 2 + 'px', height: size * 1.5 + 2 + 'px'}"
  >
    <div
      class="loadIcon"
      :style="{width: size + 'px', height: size + 'px', 'border-width': (size / 10) + 'px'}"
    />
  </div>
</template>

<script>
export default {
  name: 'LoadIcon',
  props: {
    size: {
      type: Number,
      default: 20,
    },
  },
};
</script>
<style lang="scss"> // eslint-disable-line vue-scoped-css/enforce-style-type
/* This cannot be scoped or the animation will break */
#loadIconContainer {
  width: 32px;
  height: 32px;
  padding: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loadIcon {
  border-style: solid;
  border-color: main.$npGray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border-top-color: transparent;
  animation: spin 2s infinite linear;
}
</style>
